import { connect, FormikValues } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { FilterSelect } from '@/components/Form'
import { FormLabel } from '@/components/StyledComponents'
import { StyledDateTimePicker } from '@/pages/SpaceAppBuilder/components/StyledComponents'

import { ScheduledIntervalType } from './interfaces'
import messages from './messages'
import { getDaysOfWeek } from './utils'

const StyledFilterSelect = styled(FilterSelect)`
  && {
    .ui.multiple.search.dropdown > .text {
      margin-top: 8px;
      color: gray;
    }
    .field__wrapper .ui.dropdown.multiple > a.label {
      font-size: 0.9rem;
      background-color: #ffffff;
      margin-top: 5px;
      border: none;
      color: #000000;
      > .delete.icon {
        margin-top: -1px;
      }
    }
  }
`

function Weekly({ formik, readOnly }: ScheduledIntervalType & FormikValues) {
  const intl = useIntl()

  const { values, setFieldValue } = formik
  return (
    <>
      <StyledFilterSelect
        disabled={readOnly}
        label={<FormattedMessage {...messages.every} />}
        name="triggerData.days"
        multiple
        closeOnChange
        placeholder={intl.formatMessage(messages.pleaseSelectDays)}
        options={getDaysOfWeek(intl)}
        className="fill-space"
      />
      <FormLabel>{intl.formatMessage(messages.at)}</FormLabel>
      <StyledDateTimePicker
        readOnly={readOnly}
        name="triggerData.time"
        showIcon={true}
        showTimeOnly={true}
        dateFormat="h:mm aa"
        placeholderText={intl.formatMessage(messages.pleaseSelectTime)}
        value={values.triggerData.time}
        onChange={setFieldValue}
      />
    </>
  )
}

export default connect(Weekly)
